import { useCertificates } from "@/queries/queries"
import Loading from "@/components/Loading/Loading"
import NoMessage from "@/components/noMessage/NoMessage"
import { useTranslation } from "react-i18next"
import CertificateCard from "./CertificateCard"

export default function CertificatesList() {
  const { data, isLoading } = useCertificates()
  const { t } = useTranslation()

  if (isLoading) return <Loading />
  if (!data || data.length === 0)
    return <NoMessage name={t("pageTitles.certificates", "Certificates")} />

  return (
    <div className="row">
      {data.map((certificate) => (
        <div key={certificate.id} className="col-12 col-md-6 col-lg-4">
          <CertificateCard certificate={certificate} />
        </div>
      ))}
    </div>
  )
}
